import Handler from "../Handler";
class HappyHoursInfoHandler extends Handler {
  execute(data) {
    let message = JSON.parse(data);
    this.service.processHappyHoursInfo(message);
  }
}

export default HappyHoursInfoHandler;